(() => {
  const clean = value => (value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  const label = element => clean(element.textContent).replace(/:$/, '');
  const kind = element => {
    if (!element || !/^(H[1-6]|P|DIV|SECTION)$/.test(element.tagName)) return null;
    const value = label(element).toLowerCase();
    if (/^ideal f[üu]r$/.test(value)) return 'ideal';
    if (/^merkmale$/.test(value)) return 'features';
    const shortLabel = /^H[1-6]$/.test(element.tagName) || (value.length < 150 && !element.querySelector('br,ul,ol,table'));
    if (shortLabel && /^technische daten/.test(value)) return 'technical';
    if (shortLabel && /^(qualitätsstufe|qualitaetsstufe)/.test(value)) return 'quality';
    if (/^(essential|premium|signature) collection$/.test(value)) return 'quality';
    if (shortLabel && /^produktinformationen/.test(value)) return 'information';
    return null;
  };
  const names = { ideal: 'Ideal für', features: 'Merkmale', technical: 'Technische Daten', information: 'Produktinformationen' };

  function normaliseDescription(description) {
    if (description.dataset.sfUnified === 'true') return;
    // Flatten wrappers only when they contain recognised section headings.
    let changed = true;
    while (changed) {
      changed = false;
      [...description.children].forEach(child => {
        if (!['DIV', 'SECTION', 'ARTICLE'].includes(child.tagName) || child.querySelector('table,iframe,video')) return;
        if ([...child.querySelectorAll('h1,h2,h3,h4,p')].some(el => kind(el))) {
          child.replaceWith(...child.childNodes);
          changed = true;
        }
      });
    }
    // Reset source-specific typography, never product content.
    description.querySelectorAll('[style]').forEach(el => {
      ['font-size', 'line-height', 'font-family', 'height', 'min-height', 'max-height', 'width', 'max-width', 'margin-top', 'margin-bottom'].forEach(property => el.style.removeProperty(property));
    });
    [...description.querySelectorAll('p,h1,h2,h3,h4,h5,h6')].forEach(el => {
      if (!clean(el.textContent) && !el.querySelector('img,video,iframe,svg')) el.remove();
    });
    const nodes = [...description.childNodes];
    const parts = []; let current = { type: 'introduction', heading: null, nodes: [] };
    parts.push(current);
    nodes.forEach(node => {
      let type = node.nodeType === 1 ? kind(node) : null;
      if (type === 'information' && parts.some(part => part.type === 'quality')) type = 'technical';
      if (type) {
        current = { type, heading: node, nodes: [] }; parts.push(current);
      } else current.nodes.push(node);
    });
    const infoParts = parts.filter(p => p.type === 'introduction' || p.type === 'information');
    const qualityParts = parts.filter(p => p.type === 'quality');
    const detailsParts = parts.filter(p => ['ideal', 'features', 'technical'].includes(p.type));
    const fragment = document.createDocumentFragment();
    const info = document.createElement('section'); info.className = 'sf-description-info';
    const heading = document.createElement('h2'); heading.textContent = 'Produktinformationen'; info.append(heading);
    infoParts.forEach(part => {
      part.nodes.forEach(node => {
        if (node.tagName === 'UL' && part.type === 'information' && [...node.children].length && [...node.children].every(li => clean(li.textContent).includes(':'))) {
          const list = document.createElement('dl'); list.className = 'sf-information-list';
          [...node.children].forEach(item => {
            const plain = clean(item.textContent); const pos = plain.indexOf(':');
            const term = document.createElement('dt'); term.textContent = plain.slice(0, pos).trim() + ' ';
            if (/^gewährleistung$/i.test(term.textContent.trim())) term.classList.add('sf-information-term--single-line');
            const value = document.createElement('dd');
            // Retain links and emphasis in the value, including split text spans.
            const range = document.createRange(); range.selectNodeContents(item);
            const walker = document.createTreeWalker(item, NodeFilter.SHOW_TEXT); let textNode;
            while ((textNode = walker.nextNode())) {
              const rawPos = textNode.textContent.indexOf(':');
              if (rawPos >= 0) { range.setStart(textNode, rawPos + 1); break; }
            }
            if (textNode) value.append(range.cloneContents()); else value.textContent = plain.slice(pos + 1).trim();
            value.append(document.createTextNode(' '));
            list.append(term, value);
          });
          info.append(list);
        } else info.append(node);
      });
    });
    if (info.childNodes.length > 1) fragment.append(info);
    qualityParts.forEach(part => {
      const section = document.createElement('section'); section.className = 'sf-description-quality';
      const heading = document.createElement('h2'); heading.textContent = label(part.heading).replace(/^Qualit[äa]tsstufe\s*:\s*/i, '');
      const summary = document.createElement('p');
      const collection = clean(heading.textContent).toLowerCase();
      summary.textContent = collection.includes('premium') ? 'Hochwertig technisch und optisch aufbereitet.' : collection.includes('signature') ? 'Exklusive Geräte, technisch überarbeitet und nahezu neuwertig.' : collection.includes('essential') ? 'Professionell geprüft und technisch aufbereitet.' : '';
      section.append(heading);
      if (summary.textContent) section.append(summary);
      if (part.nodes.some(node => clean(node.textContent) || (node.nodeType === 1 && node.querySelector('img,video,iframe')))) {
        const complete = document.createElement('details'); complete.className = 'sf-quality-description';
        const toggle = document.createElement('summary'); toggle.textContent = 'Mehr zur Qualitätsstufe';
        complete.append(toggle, ...part.nodes); section.append(complete);
      }
      fragment.append(section);
    });
    ['ideal', 'features', 'technical'].forEach(type => {
      detailsParts.filter(p => p.type === type).forEach(part => {
        const details = document.createElement('details'); details.className = 'sf-description-accordion'; details.dataset.sfKind = type;
        const summary = document.createElement('summary'); summary.textContent = names[type]; details.append(summary);
        const body = document.createElement('div'); body.className = 'sf-accordion-content';
        body.append(...part.nodes); details.append(body); fragment.append(details);
      });
    });
    // A description without recognised sections remains readable and complete.
    description.replaceChildren(fragment);
    description.dataset.sfUnified = 'true';
  }

  function fitPrices(root) {
    root.querySelectorAll('[data-sf-price]').forEach(price => {
      const sale = price.querySelector('.sf-sale-price'), row = price.querySelector('.sf-discount-row');
      if (!sale || !row) return;
      row.style.removeProperty('font-size'); row.style.removeProperty('transform');
      const target = sale.getBoundingClientRect().width;
      let size = parseFloat(getComputedStyle(row).fontSize);
      for (let step = 0; step < 12 && row.getBoundingClientRect().width > target + .5; step++) {
        size *= .95; row.style.fontSize = size + 'px';
      }
    });
  }

  function setup(root) {
    root.querySelectorAll('[data-sf-payment-options]').forEach(button => {
      const buy = button.form?.querySelector('[name="add"]:not([data-sf-payment-options])');
      button.disabled = !buy || buy.disabled || buy.getAttribute('aria-disabled') === 'true';
    });
    root.querySelectorAll('.sf-product-description-block').forEach(normaliseDescription);
    fitPrices(root);
    root.querySelectorAll('product-form form').forEach(form => {
      if (form.dataset.sfPaymentHandler) return;
      form.dataset.sfPaymentHandler = 'true';
      // Use Shopify's native add-to-cart redirect for the alternative payment link.
      // Only runs after the visitor clicks, never during assistant testing.
      form.addEventListener('submit', event => {
        if (!event.submitter || !event.submitter.matches('[data-sf-payment-options]')) return;
        event.preventDefault(); event.stopImmediatePropagation();
        const buy = form.querySelector('[name="add"]:not([data-sf-payment-options])');
        const variant = form.querySelector('[name="id"]');
        if (!variant || variant.disabled || !variant.value || (buy && (buy.disabled || buy.getAttribute('aria-disabled') === 'true'))) return;
        let redirect = form.querySelector('input[name="return_to"]');
        if (!redirect) { redirect = document.createElement('input'); redirect.type = 'hidden'; redirect.name = 'return_to'; form.append(redirect); }
        redirect.value = '/checkout';
        HTMLFormElement.prototype.submit.call(form);
        redirect.remove();
      }, true);
    });
  }
  const initialise = scope => (scope || document).querySelectorAll('product-info.sf-product-unified').forEach(root => {
    setup(root);
    if (root.dataset.sfObserver) return;
    root.dataset.sfObserver = 'true';
    let scheduled = false;
    new MutationObserver(records => {
      if (!records.some(r => r.type === 'childList' || (r.type === 'attributes' && r.target.matches('.product-form__submit'))) || scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; setup(root); });
    }).observe(root, { childList: true, attributes: true, attributeFilter: ['disabled','aria-disabled'], subtree: true });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target.parentElement || document));
  window.addEventListener('resize', () => document.querySelectorAll('product-info.sf-product-unified').forEach(fitPrices));
  if (document.fonts) document.fonts.ready.then(() => document.querySelectorAll('product-info.sf-product-unified').forEach(fitPrices));
})();
